import { combineReducers } from 'redux';
import reduceReducers from 'reduce-reducers';
import { reducer as formReducer } from 'redux-form';
import requirements from "./reducers/requirements";
import application from "./reducers/application";
import noteTemplates from "./reducers/note_templates";
import studentApplications from "./reducers/student_applications";
import jsonapiHelper from "./reducers/jsonapi_helper";
import invoiceSidebar from "./reducers/invoice_sidebar";
import custom_fields from "./reducers/custom_fields";
import ielts_modal from "./reducers/ielts_modal";
import rolesReducer from "./reducers/roles";
import modals from "./reducers/modals_reducer";
import search from "./reducers/search";
import crossSliceReducer from "./profile_page/reducers/crossSliceReducer";
import pageReducer from "./profile_page/reducers/pageReducer";
import cardReducer from "./profile_page/reducers/cardReducer";
import schoolInfo from "./profile_page/reducers/schoolInfoReducer";
import stats from "./profile_page/reducers/statReducer";
import location from "./profile_page/reducers/locationReducer";
import alumni from "./profile_page/reducers/alumniReducer";
import filterOptions from "./profile_page/reducers/filterOptionsReducer";
import profileReducer from "./profile_page/reducers/profileReducer";
import pageOptionsReducer from "./profile_page/reducers/pageOptionsReducer";
var appReducer = combineReducers({
  api: jsonapiHelper,
  requirements: requirements,
  application: application,
  noteTemplates: noteTemplates,
  studentApplications: studentApplications,
  invoiceSidebar: invoiceSidebar,
  custom_fields: custom_fields,
  ielts_modal: ielts_modal,
  rolesReducer: rolesReducer,
  form: formReducer,
  modals: modals,
  search: search,
  // Profile
  page: pageReducer,
  card: cardReducer,
  schoolInfo: schoolInfo,
  stats: stats,
  location: location,
  alumni: alumni,
  filterOptions: filterOptions,
  pageOptions: pageOptionsReducer,
  profile: profileReducer
});
var rootReducer = function rootReducer(_state, action) {
  var state = action.type === '@CLEAR' ? undefined : _state;
  return appReducer(state, action);
};
export default reduceReducers(rootReducer, crossSliceReducer);